import { useIsTradeInApplied } from '~/context/common/TradeContext';
import { useTradeInfo } from '~/context/srp/SearchContext';

function useHasActiveTradeApplied() {
  const isTradeInApplied = useIsTradeInApplied();
  const tradeInfo = useTradeInfo();

  return isTradeInApplied && tradeInfo?.applyTradeIn === true;
}

export default useHasActiveTradeApplied;
